export default __webpack_public_path__ + "static/media/2025_Miki_et_al_2025_PhysicaD.81e25303.pdf";